import * as d3 from 'd3'
import emptyThumb from '../../assets/images/emptydata.svg'
import './styles.css'
import Chart from '../../ultils/Chart'
import d3tip from '../../ultils/d3-tip'

class Context extends Chart {
  init({ data, events, triggerBrush, registerTimeChange }) {
    let vis = this
    vis.data = data
    vis.events = events
    vis.triggerBrush = triggerBrush

    vis.tip = d3tip()
      .attr('class', 'd3-tip')
      .html((e, d) => {
        return `
          <div class="tip-content">
            <div class="tip-header">
              <div class="tip-title">
                  ${d.title}
              </div>
              <div class="tip-date">
                <span class="tip-ticker">${d.ticker}</span>
                <span style="float:right">${d.signal_date}</span>
              </div>
            </div>
            <hr/>
            <div class="tip-body">${d.content || ''}</div>
          </div>
        `
      })

    vis.linePath = vis.g
      .append('path')
      .attr('class', 'line')
      .attr('fill', 'none')
      .attr('stroke', '#3393F3')
      .attr('stroke-width', '1.5px')

    vis.x = d3.scaleBand()
    vis.xTime = d3.scaleTime()
    vis.y = d3.scaleLinear()
    vis.y1 = d3.scaleLinear()

    vis.xAxisCall = d3.axisBottom().ticks(7).tickFormat(d3.timeFormat('%b %Y'))
    vis.xAxis = vis.g
      .append('g')
      .attr('class', 'x-axis')
      .attr('transform', `translate(0, ${vis.HEIGHT})`)
      .attr('fill', '#3393F3')

    vis.brush = d3.brushX().on('brush end', e => {
      triggerBrush(e, vis)
      var s = e.selection
      if (s == null) {
        vis.handle.attr('display', 'none')
      } else {
        vis.handle
          .attr('display', null)
          .attr(
            'transform',
            (d, i) => 'translate(' + [s[i] - 5, vis.HEIGHT / 2 - 9] + ')',
          )
      }
    })

    vis.brush.extent([
      [0, 0],
      [vis.WIDTH, vis.HEIGHT],
    ])

    vis.brushG = vis.g.append('g').attr('class', 'brush')
    vis.brushG.call(vis.brush)

    vis.handle = vis.brushG
      .selectAll('.handle--custom')
      .data([{ type: 'w' }, { type: 'e' }])
      .enter()
      .append('g')
      .attr('cursor', 'ew-resize')

    vis.handle
      .append('rect')
      .attr('width', 10)
      .attr('height', 18)
      .attr('x', 0)
      .attr('y', 0)
      .attr('rx', 0.5)
      .attr('fill', 'white')
      .attr('stroke', '#C1CFDF')
    vis.handle
      .append('path')
      .attr('stroke', '#C1CFDF')
      .attr(
        'd',
        'M3.66669 5L3.66669 13H4.55558V5H3.66669ZM6.33335 13V5H5.44446V13H6.33335Z',
      )

    vis.line = d3
      .line()
      .curve(d3.curveCatmullRom)
      .x(d => vis.xTime(d.date))
      .y(d => vis.y1(d.Open))

    vis.g.call(vis.tip)

    registerTimeChange(vis)
    vis.update({ data: vis.data })
  }

  update({ data, events }) {
    let vis = this
    vis.data = data || vis.data
    vis.events = events || vis.events
    vis.svg.selectAll('image').remove()

    if (vis.data.length <= 1) {
      vis.data = []
      vis.svg
        .append('svg:image')
        .attr('xlink:href', emptyThumb)
        .attr('x', vis.WIDTH / 2 - 77 + vis.MARGIN.LEFT)
        .attr('y', vis.HEIGHT / 2 - 37 + vis.MARGIN.TOP)
        .attr('width', '155')
        .attr('height', '73')
    }

    vis.brush.extent([
      [0, 0],
      [vis.WIDTH, vis.HEIGHT],
    ])

    vis.t = () => d3.transition().duration(1000)

    vis.x
      .range([0, vis.WIDTH])
      .domain(vis.data.map(d => d.p_date))
      .padding(0.1)
    vis.xTime.range([0, vis.WIDTH]).domain(d3.extent(vis.data, d => d.date))
    vis.y
      .range([vis.HEIGHT, 0])
      .domain([0, d3.max(vis.data, d => Number(d.p_volume))])
    vis.y1
      .range([vis.HEIGHT, 0])
      .domain([
        d3.min(vis.data, d => Number(d.Open)),
        d3.max(vis.data, d => Number(d.Open)) * 1.05,
      ])

    vis.xAxisCall.scale(vis.xTime)
    vis.xAxis.transition(vis.t()).call(vis.xAxisCall)

    vis.linePath.attr('d', vis.line(vis.data))

    vis.xAxis
      .selectAll('.domain')
      .attr('stroke', '#C1CFDF')
      .attr('stroke-width', '1')

    vis.xAxis
      .selectAll('.tick line')
      .attr('x1', 0)
      .attr('y1', 0)
      .attr('x2', 0)
      .attr('y2', 6)
      .attr('stroke', '#DFE4EB')
      .attr('stroke-width', '1')

    vis.xAxis.selectAll('.tick text').attr('class', 'tickTextContextChart')
    vis.g.selectAll('.overlay').attr('fill', 'rgba(51, 147, 243, 0.1)')
    vis.g.selectAll('.selection').attr('fill', 'rgba(51, 147, 243, 0.5)')
  }

  zoomed = ({ sourceEvent, transform }) => {
    if (!sourceEvent) return // ignore zoom-by-brush
    const vis = this
    vis.g
      .select('.brush')
      .call(vis.brush.move, vis.xTime.range().map(transform.invertX, transform))
  }
}

export default Context
